<template>
  <v-card>
    <v-tabs :value="tabMenu">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab @click="fetchSubMember()">Sub Member</v-tab>
      <v-tab v-show="displayReviewTab" @click="fetchDetails()">Details</v-tab>
      <v-tab-item>
        <transition name="slide-x-transition" mode="out-in">
          <router-view :key="routeKey"></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayReviewTab">
        <transition name="slide-x-transition" mode="out-in">
          <router-view :key="routeKey"></router-view>
        </transition>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
    this.fetchSubMember()
  },
  methods: {
    fetchSubMember() {
      const commitData = {
        tabMenu: 0,
        displayReviewTab: false
      }
      this.$store.commit('TABMENU', commitData)
      this.$router.push({ name: 'subMemberList' })
    },
    fetchDetails() {
      const commitData = {
        tabMenu: 1,
        displayReviewTab: true
      }
      this.$store.commit('TABMENU', commitData)
      this.$router.push({ name: 'subMemberDet' })
    }
  },
  computed: {
    tabMenu() {
      return this.$store.state.adminUser.member.tabMenu.tab
    },
    displayReviewTab() {
      return this.$store.state.adminUser.member.tabMenu.displayReviewTab
    },
    routeKey() {
      if (this.$route.matched && this.$route.matched.length > 0) {
        // This is to solve the route loading fail for pages with same component
        // Eg: SubRoute - Vue JS will reuse same component for same route level, thus not triggering the lifeCycle methods
        // Note: this will only solve the problem for index 0 route
        return this.$route.matched[0].name
      }
      return ''
    }
  },
  props: ['id']
}
</script>

<style>
</style>
